<template>
  <AppLayout>
    <div class="col-12 layout-spacing">
      <div class="widget widget-six">
        <settingsMenu></settingsMenu>
        <div class="widget-heading">
          <div class="row">
            <div class="col-12 d-inline-flex align-items-center">
              <h4 class="me-3 my-0">Zakresy godzin pracy</h4>
              <button @click="addTyp" class="btn btn-primary btn-sm">
                <i class="bi bi-plus-circle me-2"></i>Dodaj nowy zakres godzin
              </button>
            </div>
          </div>
        </div>
        <div class="widget-content">
          <div class="custom-table">
            <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                <tr>
                  <th>#</th>
                  <th>Nazwa zakresu</th>
                  <th>Godzina rozpoczęcia</th>
                  <th>Godzina zakończenia</th>
                  <th>Akcje</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(typ, index) in typy_godzin" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td>
                    <input v-if="editingId === typ.id" v-model="typ.nazwa" class="form-control"/>
                    <span v-else>{{ typ.nazwa }}</span>
                  </td>
                  <td>
                    <input v-if="editingId === typ.id" v-model="typ.start" class="form-control" type="number"/>
                    <span v-else>{{ typ.start }}</span>
                  </td>
                  <td>
                    <input v-if="editingId === typ.id" v-model="typ.koniec" class="form-control" type="number"/>
                    <span v-else>{{ typ.koniec }}</span>
                  </td>
                  <td>
                    <button v-if="editingId === typ.id" @click="updateTyp(typ)" class="btn btn-sm btn-success me-2">
                      Zapisz
                    </button>
                    <button v-else @click="editTyp(typ.id)" class="btn btn-sm btn-outline-info me-2"><i
                        class="bi bi-pencil me-2"></i>Edytuj
                    </button>
                    <button @click="deleteTyp(typ.id)" class="btn btn-sm btn-danger"><i class="bi bi-trash me-2"></i>Usuń
                    </button>
                  </td>
                </tr>
                <tr v-if="addingNew">
                  <td>Nowy</td>
                  <td><input v-model="newTyp.nazwa" class="form-control"/></td>
                  <td><input v-model="newTyp.start" class="form-control"/></td>
                  <td><input v-model="newTyp.koniec" class="form-control"/></td>
                  <td>
                    <button @click="saveNewTyp" class="btn btn-sm btn-success me-1"><i class="bi bi-save me-2"></i>Zapisz
                    </button>
                    <button @click="cancelNewTyp" class="btn btn-sm btn-danger"><i class="bi bi-x-circle me-2"></i>Anuluj
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import {usePermission} from "@/composables/resources/js/composables/permissions.js";
import settingsMenu from "@/Pages/Kadry/parts/settingsMenu.vue";

const {hasPermission} = usePermission();

export default {
  components: {AppLayout, settingsMenu},
  props: {
    typy_godzin: Array
  },
  data() {
    return {
      hasPermission,
      editingId: null,
      addingNew: false,
      newTyp: this.getEmptyForm()
    };
  },
  methods: {
    formatDate(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp);
      return date.toISOString().split('T')[0];
    },
    getEmptyForm() {
      return {
        id: null,
        name: ''
      };
    },
    addTyp() {
      this.addingNew = true;
      this.newTyp = this.getEmptyForm();
    },
    cancelNewTyp() {
      this.addingNew = false;
      this.newTyp = this.getEmptyForm();
    },
    editTyp(id) {
      this.editingId = id;
    },

    updateTyp(typ) {
      this.$inertia.put(route('kadry.typy_godzin.update', typ.id), typ, {
        onSuccess: () => {
          this.editingId = null;
        }
      });
    },
    saveNewTyp() {
      this.$inertia.post(route('kadry.typy_godzin.dodaj'), this.newTyp, {
        onSuccess: () => {
          this.addingNew = false;
          this.newTyp = this.getEmptyForm();
        }
      });
    },
    deleteTyp(id) {
      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Usuwanie typu umowy',
        html: 'Czy na pewno chcesz usunąć wybrany zakres godzin?',
        showDenyButton: true,
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie',
        timer: false,
        position: 'center'
      }).then((result) => {
        if (result.isConfirmed) {
          this.$inertia.delete(route('kadry.typy_godzin.usun', id));
        }
      });
    }
  }
};
</script>

